<script>

import TokenTransactionsTable from "@/components/tokenTransactions/TokenTransactionsTable.vue";
import SendTokensModal from "@/components/modals/SendTokensModal.vue";
import SendTokensFromFileModal from "@/components/modals/SendTokensFromFileModal.vue";

export default {
    components: {SendTokensFromFileModal, SendTokensModal, TokenTransactionsTable},

    data() {
        return {
            tokenTransactions: [],
            adminTransactions: [],
            loading: {
                tokenTransactions: true,
                adminTransactions: true,
                data: true
            },
            controller: {
                tokenTransactions: null,
                adminTransactions: null,
            },
            data: null,
            sendModalOpened: false,
            sendCSVModalOpened: false,
        }
    },
    methods: {
        openSendCsvModal() {
            this.sendCSVModalOpened = true;
            this.$modal.open();
        },
        closeSendCsvModal(data) {
            if (data && data.requestSent) {
                this.loadDashboardData();
                this.loadTokenTransactions();
            }
            this.$modal.close();
            this.sendCSVModalOpened = false;
        },
        openSendModal() {
            this.sendModalOpened = true;
            this.$modal.open();
        },
        closeSendModal(data) {
            if (data && data.requestSent) {
                this.loadDashboardData();
                this.loadTokenTransactions();
            }
            this.$modal.close();
            this.sendModalOpened = false;
        },
        loadTokenTransactions() {
            this.controller.tokenTransactions = new AbortController();
            axios.get('/token-transactions', {
                signal: this.controller.tokenTransactions.signal,
                params: {
                    per_page: 10,
                    page: 1
                }
            }).then(response => {
                this.tokenTransactions = response.data.data;
            }).finally(() => {
                this.loading.tokenTransactions = false;
            })
        },
        loadAdminTransactions() {
            this.controller.adminTransactions = new AbortController();
            axios.get('/token-transactions/administration', {
                signal: this.controller.adminTransactions.signal,
                params: {
                    per_page: 10,
                    page: 1
                }
            }).then(response => {
                this.adminTransactions = response.data.data;
            }).finally(() => {
                this.loading.adminTransactions = false;
            })
        },
        loadDashboardData() {
            this.controller.dashboard = new AbortController();
            axios.get('/dashboard', {
                signal: this.controller.dashboard.signal
            }).then(response => {
                this.data = response.data;
            }).finally(() => {
                this.loading.data = false;
            })
        },
        loadDashboard() {
            this.loadTokenTransactions();
            this.loadAdminTransactions();
            this.loadDashboardData();
        }
    },
    mounted() {
        this.loadDashboard();
    }
}
</script>

<template>
    <section class="dashboard">
        <loader :loading="loading.data"></loader>
        <div v-if="!loading.data" class="block">

            <div class="info-cards-container mb-6 mt-6 is-flex is-justify-content-center is-align-items-stretch">
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-3 mb-4">{{ data.token_balance }} </div>
                        <div class="subtitle is-6">{{ $t('dashboard.tokens_amount') }}</div>
                    </div>
                </div>
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-3 mb-4">
                            {{ data.tokens_pending }}
                        </div>
                        <div class="subtitle is-6">{{ $t('dashboard.employer.tokens_pending') }}</div>
                    </div>
                </div>
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-3 mb-4">
                            {{ data.pending_withdrawals }}
                        </div>
                        <div class="subtitle is-6">{{ $t('dashboard.employer.withdrawals_pending') }}</div>
                    </div>
                </div>
            </div>

            <section class="buttons">
                <button class="button is-primary" @click="$router.push({name: 'tokens.buy'})">
                    {{ $t('dashboard.employer.actions.buy_tokens') }}
                </button>
                <button class="button is-link" @click="openSendModal">
                    {{ $t('dashboard.employer.actions.send_tokens') }}
                </button>
                <button class="button is-link" @click="openSendCsvModal">
                    {{ $t('dashboard.employer.actions.csv_send_tokens') }}
                </button>
            </section>

            <SendTokensModal v-if="sendModalOpened"
                               v-on:sent="loadDashboard()"
                               v-on:close="closeSendModal"/>

            <SendTokensFromFileModal v-if="sendCSVModalOpened"
                               v-on:sent="loadDashboard()"
                               v-on:close="closeSendCsvModal"/>

        </div>

        <div class="block">
            <div class="section-title is-size-5 is-uppercase">
                {{ $t('dashboard.labels.last_transactions') }}
            </div>

            <loader :loading="loading.tokenTransactions"/>

            <div class="block has-text-grey has-text-centered mb-4 mt-4" v-if="tokenTransactions.length === 0 && !loading.tokenTransactions">
                {{ $t('dashboard.labels.no_transactions') }}
            </div>

            <TokenTransactionsTable
                v-if="tokenTransactions.length"
                :data="tokenTransactions"
                :loading="loading.tokenTransactions"
                :detailsView="false"
                :show-per-page="false"
                :paginated="false"
            />

        </div>


        <div class="block">
            <div class="section-title is-size-5 is-uppercase">
                {{ $t('dashboard.labels.last_transactions_with_administration') }}
            </div>

            <loader :loading="loading.adminTransactions"/>

            <div class="block has-text-grey has-text-centered mb-4 mt-4" v-if="adminTransactions.length === 0 && !loading.adminTransactions">
                {{ $t('dashboard.labels.no_transactions') }}
            </div>

            <TokenTransactionsTable
                v-if="adminTransactions.length"
                :data="adminTransactions"
                :loading="loading.adminTransactions"
                :detailsView="false"
                :show-per-page="false"
                :paginated="false"
            />
        </div>

    </section>
</template>
